import React, { useState } from "react";
import Scheduler from "devextreme-react/scheduler";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { useEffect } from "react";
import { function_VEN_Reservas_Cabecera_ResumenEventos } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import { DateBox } from "devextreme-react";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";

const sumarDias = (fecha, dias) => {
  const nuevaFecha = new Date(fecha);
  nuevaFecha.setDate(nuevaFecha.getDate() + dias);
  return nuevaFecha;
};

export const VEN_Reservas_ResumenDeEventos_Calendario = () => {
  const [data, setData] = useState([]);
  const base = new Date();
  const [FechaDesde, setFechaDesde] = useState(new Date(base.getFullYear(), base.getMonth(), base.getDate() - 7));
  const [FechaHasta, setFechaHasta] = useState(new Date(base.getFullYear(), base.getMonth(), base.getDate() + 30));

  const getData = async () => {
    try {
      const resultData = await function_VEN_Reservas_Cabecera_ResumenEventos(FormateoFechaPara_yyyyMMdd(FechaDesde), FormateoFechaPara_yyyyMMdd(FechaHasta))

      setData(
        resultData.data.map(item => ({
          ...item,
          startDate: item.FechaInicio,
          endDate: item.FechaFin,
          text: `Reserva: ${item.IdReserva} -  Agasajado: ${item.Cliente.toUpperCase()} - Tipo: ${item.Articulo} - Tipo: ${item.FechaInicio} - Participantes: ${item.Participantes}`
        }))
      );
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    getData()
  }, []);

  useEffect(() => {
    getData();
  }, [FechaDesde, FechaHasta]);

  return (
    <PaginaCarga
      Titulo="RESUMEN DE EVENTOS (Vista Calendario)"
    >
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
          <label>Rango de Datos</label>
          <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaDesde} onValueChanged={(e) => setFechaDesde(e.value)} />
          <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaHasta} onValueChanged={(e) => setFechaHasta(e.value)} />
        </div>

        <div className="dx-card">
          <Scheduler
            dataSource={data}
            views={["agenda"]}
            defaultCurrentView="agenda" 
            showCurrentTimeIndicator={true}
            showAllDayPanel={false}
            shadeUntilCurrentTime={true}
            currentDate={new Date()}
            editing={false}
            textExpr="text"
            startDateExpr="startDate"
            endDateExpr="endDate"
            height={700}
          />
        </div>
      </div>
    </PaginaCarga>
  );
};
